export { BasePhotoModule } from './components/base-photo';
export { BasePhotoWrapperComponent } from './components/base-photo-wrapper/base-photo-wrapper.component';
export { convertFileToMultimedia, validateFileExtension } from './components/base-photo/utils';
